module.exports = __webpack_public_path__ + "static/media/image-8.39f24592.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/image-8.jpg
// module id = 369
// module chunks = 0